import { HTMLAttributes, memo, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    title: string;
    count?: number;
    onClick?: any;
}

export function PolicyCount({ title, count, onClick }: Props): ReactElement {

    return (
        <div className="policy-count">
            <span className="title">
                {title}
            </span>
            <span className="count">
                {count}
            </span>
            <span className="action" onClick={onClick}>
                عملیات
            </span>
        </div>
    )
}
export default memo(PolicyCount);